import * as React from "react";
import { UsuarioDetalhe } from "./detalhe";
import { UsuarioBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const UsuarioPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.user.titlePage"));

  return (
    <React.Fragment>
      <UsuarioDetalhe />
      <UsuarioBottom />
    </React.Fragment>
  );
};
